import constantObject from 'utilities/constantObject';

export const BUZZ_ENDPOINT_LIMITS = {
  PINNED_CHANNELS: 200,
  PINNED_CHANNELS_HUDDLES: 50,
  PINNED_CHANNELS_MESSAGES: 3,
  RECENT_ACTIVITY_CHANNELS: 20,
  RECENT_ACTIVITY_CHANNELS_MESSAGES: 3,
  TOPICS: 50,
  USERS: 50,
};

export const BUZZ_CHANNEL_TYPES = {
  GENERAL_TOPIC: 'Topic',
  OBJECT_TOPIC: 'ObjectChat',
  DIRECT_CHAT: 'DirectChat',
  GROUP_CHAT: 'GroupChat',
  HUDDLE: 'Huddle',
};

export const BUZZ_CHANNEL_CATEGORIES = constantObject([
  'PUBLIC_GENERAL_TOPIC',
  'PRIVATE_GENERAL_TOPIC',
  'PAGE_OBJECT_TOPIC',
  'CARD_OBJECT_TOPIC',
  'PROJECT_OBJECT_TOPIC',
  'APPROVAL_OBJECT_TOPIC',
  'DIRECT_CHAT',
  'PUBLIC_HUDDLE',
  'PRIVATE_HUDDLE',
]);

export const BUZZ_SHAREABLE_RESOURCE_TYPES = constantObject([
  'CARD',
  'PAGE',
  'PROJECT',
  'BUZZ_CHANNEL',
]);

export const BUZZ_QUERY_PARAM_CHANNEL_TYPES = {
  DIRECT_CHAT: 'DIRECT_CHAT',
  GENERAL_TOPIC: 'TOPIC',
  GROUP_CHAT: 'GROUP_CHAT',
  HUDDLE: 'HUDDLE',
  OBJECT_TOPIC: 'OBJECT_CHAT',
};

export const BUZZ_QUERY_PARAM_TITLE_MODES = constantObject(['CONTAINS']);

export const BUZZ_QUERY_PARAM_SORT_MODES = {
  ALPHABETICAL: 'ALPHA_BY_TITLE',
  MOST_RECENT: 'MOST_RECENT',
  MOST_RECENT_EXCLUDING_HUDDLES: 'MOST_RECENT_EXCLUDING_HUDDLES',
};

export const BUZZ_TOPIC_CHANNEL_TYPES = [BUZZ_CHANNEL_TYPES.OBJECT_TOPIC];

export const BUZZ_CHAT_CHANNEL_TYPES = [
  BUZZ_CHANNEL_TYPES.GENERAL_TOPIC,
  BUZZ_CHANNEL_TYPES.GROUP_CHAT,
  BUZZ_CHANNEL_TYPES.DIRECT_CHAT,
];

export const BUZZ_TOPIC_PUBLIC_PERMISSION_TYPES = constantObject([
  'NONE',
  'INVITE_OTHERS',
  'READ',
  'REPLY',
  'ADMIN',
]);

export const BUZZ_OBJECT_TOPIC_TYPES = constantObject([
  'CARD',
  'PAGE',
  'PROJECT',
  'APPROVAL',
]);

export const BUZZ_ACCOUNT_TYPES = constantObject([
  'USER',
  'GROUP',
  'THIRD_PARTY',
  'SYSTEM',
]);

export const BUZZ_ACCOUNT_PERMISSIONS = constantObject([
  'ADMIN',
  'INVITE_OTHERS',
  'REPLY',
  'READ',
  'NONE',
  'DENY',
]);

export const BUZZ_MESSAGE_TYPES = {
  MESSAGE: 'Message',
  HUDDLE: 'Huddle',
  SYSTEM: 'SYSTEM',
};

export const BUZZ_MESSAGE_MESSAGETYPES = constantObject([
  'THIRD_PARTY',
  'USER',
  'SYSTEM',
]);

export const BUZZ_SUPPORTED_MESSAGE_TYPES = [
  BUZZ_MESSAGE_TYPES.MESSAGE,
  BUZZ_MESSAGE_TYPES.HUDDLE,
  BUZZ_MESSAGE_TYPES.SYSTEM,
];

export const BUZZ_MESSAGE_ATTACHMENT_TYPES = constantObject([
  'FILE',
  'COMMAND',
  'CARD',
  'URL_PREVIEW',
]);

export const BUZZ_MESSAGE_ACTION_TYPES = {
  REACTION: 'reaction',
  FAVORITE: 'favorite',
  REPLY: 'reply',
};

export const BUZZ_MESSAGES_PER_PAGE = 30;

export const BUZZ_FAVORITE_POSITIONS = {
  THRESHOLD: 1,
  UNFAVORITED: -1,
};
